const products = [
    {
      id: 1,
      name: "VOYAGER 4300 UC SERIES",
      logo: require('./assets/Headsets/BluetoothHeadsets/H_VOYAGER_4320.PNG'),
      document: require('./datasheets/Headsets/BluetoothHeadsets/H_VOYAGER 4320.pdf'),
      Category: "Headsets",
      Subcategory: "Bluetooth Headsets",
    },
    {
      id: 2,
      name: "VOYAGER FOCUS 2",
      logo: require('./assets/Headsets/BluetoothHeadsets/H_VOYAGER_FOCUS2.PNG'),
      document: require('./datasheets/Headsets/BluetoothHeadsets/H_VOYAGER FOCUS2.pdf'),      
      Category: "Headsets",
      Subcategory: "Bluetooth Headsets",
    },
    {
      id: 3,      
      name: "VOYAGER SURROUND 80 SERIES",
      logo: require('./assets/Headsets/BluetoothHeadsets/H_SURROUND_80_SERIES.jpg'),
      document: require('./datasheets/Headsets/BluetoothHeadsets/H_SURROUND 80 SERIES.pdf'),
      Category: "Headsets",
      Subcategory: "Bluetooth Headsets",
    },    
    {
      id: 4,
      name: "BLACKWIRE 3200",
      logo: require('./assets/Headsets/UsbHeadsets/H_BW3200.PNG'),
      document: require('./datasheets/Headsets/UsbHeadsets/H_BW3200.pdf'),
      Category: "Headsets",
      Subcategory: "Usb Headsets",
    },
    {
      id: 5,
      name: "BLACKWIRE 3300",
      logo: require('./assets/Headsets/UsbHeadsets/H_BW3320.PNG'),
      document: require('./datasheets/Headsets/UsbHeadsets/H_BW3320.pdf'),
      Category: "Headsets",
      Subcategory: "Usb Headsets",
    },
    {
      id: 6,
      name: "BLACKWIRE 5200",
      logo: require('./assets/Headsets/UsbHeadsets/H_BW5200.PNG'),
      document: require('./datasheets/Headsets/UsbHeadsets/H_BW5200.pdf'),
      Category: "Headsets",
      Subcategory: "Usb Headsets",
    },
    {
      id: 7,
      name: "BLACKWIRE 8225",
      logo: require('./assets/Headsets/UsbHeadsets/H_BW8225.PNG'),
      document: require('./datasheets/Headsets/UsbHeadsets/H_BW8225.pdf'),
      Category: "Headsets",
      Subcategory: "Usb Headsets",
    },
    {
      id: 8,
      name: "ENCOREPRO 500 SERIES",
      logo: require('./assets/Headsets/UsbHeadsets/encorepro-500.jpg'),
      document: require('./datasheets/Headsets/UsbHeadsets/EncorePro 500 Series Data Sheet.pdf'),
      Category: "Headsets",
      Subcategory: "Usb Headsets",
    },
    {
      id: 9,
      name: "ENCOREPRO 700 SERIES",
      logo: require('./assets/Headsets/UsbHeadsets/encorepro-700.jpg'),
      document: require('./datasheets/Headsets/UsbHeadsets/EncorePro 700 Series Data Sheet.pdf'),
      Category: "Headsets",
      Subcategory: "Usb Headsets",
    },
    {
      id: 10,
      name: "TRIO C60",
      logo: require('./assets/Phones/IPConferencePhones/Poly_Trio60.jpg'),
      document: require('./datasheets/Phones/IP Conference Phones/Trio C60 Data Sheet.pdf'),
      Category: "Phones",
      Subcategory: "IP Conference Phones",
    },    
    {
      id: 11,
      name: "POLY CCX 350",
      logo: require('./assets/Phones/IPDeskPhones/CCX350_DeskPhone.jpg'),
      document: require('./datasheets/Phones/IP Desk Phones/CCX 350 Data Sheet.pdf'),
      Category: "Phones",
      Subcategory: "IP Desk Phones",
    },
    {
      id: 12,
      name: "POLY CCX 400",
      logo: require('./assets/Phones/IPDeskPhones/CCX400_DeskPhone.jpg'),
      document: require('./datasheets/Phones/IP Desk Phones/CCX 400 Data Sheet.pdf'),
      Category: "Phones",
      Subcategory: "IP Desk Phones",
    },
    {
      id: 13,
      name: "POLY CCX 500",
      logo: require('./assets/Phones/IPDeskPhones/CCX500_DeskPhone.jpg'),
      document: require('./datasheets/Phones/IP Desk Phones/CCX 500 Data Sheet.pdf'),
      Category: "Phones",
      Subcategory: "IP Desk Phones",
    },
    {
      id: 14,
      name: "POLY CCX 505",
      logo: require('./assets/Phones/IPDeskPhones/CCX505_DeskPhone.jpg'),
      document: require('./datasheets/Phones/IP Desk Phones/CCX 505 Data Sheet.pdf'),
      Category: "Phones",
      Subcategory: "IP Desk Phones",
    },
    {
      id: 15,
      name: "POLY CCX 600",
      logo: require('./assets/Phones/IPDeskPhones/CCX600_DeskPhone.jpg'),
      document: require('./datasheets/Phones/IP Desk Phones/CCX 600 Data Sheet.pdf'),
      Category: "Phones",
      Subcategory: "IP Desk Phones",
    },
    {
      id: 16,
      name: "CCX 700 SIP Datasheet.pdf",
      logo: require('./assets/Phones/IPDeskPhones/CCX700_DeskPhone.jpg'),
      document: require('./datasheets/Phones/IP Desk Phones/CCX 700 SIP Datasheet.pdf'),
      Category: "Phones",
      Subcategory: "IP Desk Phones",
    },
    {
      id: 17,
      name: "POLY EDGE E100 IP DESK PHONE",
      logo: require('./assets/Phones/IPDeskPhones/Edge_E100.jpg'),
      document: require('./datasheets/Phones/IP Desk Phones/Edge E100 Series Data Sheet.pdf'),
      Category: "Phones",
      Subcategory: "IP Desk Phones",
    },
    {
      id: 18,
      name: "POLY EDGE E220 IP DESK PHONE",
      logo: require('./assets/Phones/IPDeskPhones/Edge_E220.jpg'),
      document: require('./datasheets/Phones/IP Desk Phones/Edge E220 Series Data Sheet.pdf'),
      Category: "Phones",
      Subcategory: "IP Desk Phones",
    },
    {
      id: 19,
      name: "POLY EDGE E300 SERIES IP DESK PHONES",
      logo: require('./assets/Phones/IPDeskPhones/Edge_E300.jpg'),
      document: require('./datasheets/Phones/IP Desk Phones/Edge E300 Series Data Sheet.pdf'),
      Category: "Phones",
      Subcategory: "IP Desk Phones",
    },
    {
      id: 20,
      name: "POLY EDGE E400 SERIES IP DESK PHONES",
      logo: require('./assets/Phones/IPDeskPhones/Edge_E400.jpg'),
      document: require('./datasheets/Phones/IP Desk Phones/Edge E400 Series Data Sheet.pdf'),
      Category: "Phones",
      Subcategory: "IP Desk Phones",
    },
    {
      id: 21,
      name: "POLY EDGE E500 SERIES IP DESK PHONES",
      logo: require('./assets/Phones/IPDeskPhones/Edge_E500.jpg'),
      document: require('./datasheets/Phones/IP Desk Phones/Edge E500 Series Data Sheet.pdf'),
      Category: "Phones",
      Subcategory: "IP Desk Phones",
    },
    {
      id: 22,
      name: "POLY VVX 150 BUSINESS IP PHONE",
      logo: require('./assets/Phones/IPDeskPhones/VVX150_Deskphone.jpg'),
      document: require('./datasheets/Phones/IP Desk Phones/VOICE_VVX150.pdf'),
      Category: "Phones",
      Subcategory: "IP Desk Phones",
    },
    {
      id: 23,
      name: "POLY VVX 250 BUSINESS IP PHONE",
      logo: require('./assets/Phones/IPDeskPhones/VVX250_Deskphone.jpg'),
      document: require('./datasheets/Phones/IP Desk Phones/VOICE_VVX250.pdf'),
      Category: "Phones",
      Subcategory: "IP Desk Phones",
    },
    {
      id: 24,
      name: "POLY VVX 350 BUSINESS IP PHONE",
      logo: require('./assets/Phones/IPDeskPhones/VVX350_Deskphone.jpg'),
      document: require('./datasheets/Phones/IP Desk Phones/VOICE_VVX350.pdf'),
      Category: "Phones",
      Subcategory: "IP Desk Phones",
    },
    {
      id: 25,
      name: "POLY VVX 450 BUSINESS IP PHONE",
      logo: require('./assets/Phones/IPDeskPhones/VVX450_Deskphone.jpg'),
      document: require('./datasheets/Phones/IP Desk Phones/VOICE_VVX450.pdf'),
      Category: "Phones",
      Subcategory: "IP Desk Phones",
    },    
    {
      id: 26,
      name: "POLY SYNC 10",
      logo: require('./assets/Phones/USBBluetoothSpeakerPhones/Sync_10.jpg'),
      document: require('./datasheets/Phones/USB Bluetooth Speaker Phones/Poly Sync 10 Data Sheet.pdf'),
      Category: "Phones",
      Subcategory: "USB Bluetooth Speaker Phones",
    },    
    {
      id: 27,
      name: "POLY SYNC 20",
      logo: require('./assets/Phones/USBBluetoothSpeakerPhones/Sync_20_DeskPhone.jpg'),
      document: require('./datasheets/Phones/USB Bluetooth Speaker Phones/Poly Sync 20 Datasheet.pdf'),
      Category: "Phones",
      Subcategory: "USB Bluetooth Speaker Phones",
    },
    {
      id: 28,
      name: "POLY SYNC 40",
      logo: require('./assets/Phones/USBBluetoothSpeakerPhones/Sync_40_DeskPhone.jpg'),
      document: require('./datasheets/Phones/USB Bluetooth Speaker Phones/Poly Sync 40 Data Sheet.pdf'),
      Category: "Phones",
      Subcategory: "USB Bluetooth Speaker Phones",
    },
    {
      id: 29,
      name: "POLY SYNC 60",
      logo: require('./assets/Phones/USBBluetoothSpeakerPhones/Sync_60_DeskPhone.jpg'),
      document: require('./datasheets/Phones/USB Bluetooth Speaker Phones/Poly Sync 60 - Data Sheet.pdf'),
      Category: "Phones",
      Subcategory: "USB Bluetooth Speaker Phones",
    },
    {
      id: 30,
      name: "Poly Studio X32",
      logo: require('./assets/VideoConferencing/AllInOneSolutions/Studio_X32_VC.jpg'),
      document: require('./datasheets/Video conferencing/All in One Solutions/Poly Studio X32 Data Sheet NA.pdf'),
      Category: "Video Conferencing",
      Subcategory: "All in One Solutions",
    },    
    {
      id: 31,
      name: "Poly Studio X52",
      logo: require('./assets/VideoConferencing/AllInOneSolutions/Studio_X52_VC.jpg'),
      document: require('./datasheets/Video conferencing/All in One Solutions/Poly Studio X52 Data Sheet.pdf'),
      Category: "Video Conferencing",
      Subcategory: "All in One Solutions",
    },    
    {
      id: 32,
      name: "Poly Studio X72",
      logo: require('./assets/VideoConferencing/AllInOneSolutions/Studio_X72_VC.jpg'),
      document: require('./datasheets/Video conferencing/All in One Solutions/Poly Studio X72 Data Sheet NA.pdf'),
      Category: "Video Conferencing",
      Subcategory: "All in One Solutions",
    },    
    {
      id: 33,
      name: "POLY TC10",
      logo: require('./assets/VideoConferencing/AllInOneSolutions/TC10_VC.jpg'),
      document: require('./datasheets/Video conferencing/All in One Solutions/TC10 Data Sheet.pdf'),
      Category: "Video Conferencing",
      Subcategory: "All in One Solutions",
    },    
    {
      id: 34,
      name: "Poly Studio G62",
      logo: require('./assets/VideoConferencing/AllInOneSolutions/Studio_G62_VC.jpg'),
      document: require('./datasheets/Video conferencing/All in One Solutions/Poly Studio G62 Product Brief.pdf'),
      Category: "Video Conferencing",
      Subcategory: "Modular Solutions",
    },
    {
      id: 35,
      name: "POLY IP CEILING MICROPHONE ARRAY",
      logo: require('./assets/VideoConferencing/ModularSolutions/IPCeilingMicrophone_VC.jpg'),
      document: require('./datasheets/Video conferencing/Modular Solutions/Poly IP Ceiling Microphone Array Data Sheet.pdf'),
      Category: "Video Conferencing",
      Subcategory: "Modular Solutions",
    },
    {
      id: 36,
      name: "Poly Studio Premium USB Video Bar",
      logo: require('./assets/VideoConferencing/USBSolutions/AIO_StudioBar_VC.jpg'),
      document: require('./datasheets/Video conferencing/USB solutions/V_BYOD_AIO_STUDIO.pdf'),
      Category: "Video Conferencing",
      Subcategory: "USB Solutions",
    },
    {
      id: 37,
      name: "POLY STUDIO R30",
      logo: require('./assets/VideoConferencing/USBSolutions/R30VideoBar_VC.png'),
      document: require('./datasheets/Video conferencing/USB solutions/V_BYOD_AIO_R30.pdf'),
      Category: "Video Conferencing",
      Subcategory: "USB Solutions",
    },
    {
      id: 38,
      name: "Poly Studio E60 Smart Camera",
      logo: require('./assets/VideoConferencing/USBSolutions/AIO_StudioBar_E60_VC.jpg'),
      document: require('./datasheets/Video conferencing/USB solutions/V_BYOD_CAMERA_E60.pdf'),
      Category: "Video Conferencing",
      Subcategory: "USB Solutions",
    },
    {
      id: 39,
      name: "POLY STUDIO E70",
      logo: require('./assets/VideoConferencing/USBSolutions/E70SmartCamera_VC.png'),
      document: require('./datasheets/Video conferencing/USB solutions/V_BYOD_CAMERA_E70.pdf'),
      Category: "Video Conferencing",
      Subcategory: "USB Solutions",
    },
    {
      id: 40,
      name: "Poly Studio V52 USB Video Bar",
      logo: require('./assets/VideoConferencing/USBSolutions/AIO_StudioBar_V52_VC.jpg'),
      document: require('./datasheets/Video conferencing/USB solutions/V_BYOD_AIO_V52.pdf'),
      Category: "Video Conferencing",
      Subcategory: "USB Solutions",
    },
    {
      id: 41,
      name: "Poly Studio V72 Product Brief",
      logo: require('./assets/VideoConferencing/USBSolutions/V72_VC.jpg'),
      document: require('./datasheets/Video conferencing/USB solutions/Poly Studio V72 Product Brief.pdf'),
      Category: "Video Conferencing",
      Subcategory: "USB Solutions",
    },    
  ];
  
  export default products;